/**
 * Bridges "the backend just told us this session is no longer valid" out of
 * plain (non-component) modules — apiFetch() and usePortfolioStream() — into
 * AuthContext, which owns the actual logout + redirect-to-login state.
 *
 * Neither call site can reach AuthContext directly: apiFetch() isn't a React
 * hook/component, and usePortfolioStream() is called in places (App.tsx's
 * earn-tab stream) that shouldn't take on a hard dependency on AuthContext
 * just to report this one thing. A window CustomEvent is the standard bridge
 * for "plain module needs to talk to a React context" in this situation.
 */
const EVENT_NAME = 'defi:session-expired'

/** Call when the backend has definitively rejected the current session (a
 * real 401 on an authenticated request, or the refresh token itself being
 * invalid/expired/already-rotated) — not for transient network failures. */
export function notifySessionExpired() {
  window.dispatchEvent(new Event(EVENT_NAME))
}

/** Returns an unsubscribe function — call it from a useEffect cleanup. */
export function onSessionExpired(handler: () => void): () => void {
  window.addEventListener(EVENT_NAME, handler)
  return () => window.removeEventListener(EVENT_NAME, handler)
}
